<!--

== Base Select

Props:

    > label
    Texto descritivo do select, utilizado no label-float.


Outros requisitos:

    > v-model
    O componente atualmente precisa de um v-model para funcionar corretamente.
    option precisa de um value

-->

<template>
  <div class="label-float" :class="{ invalid: !valid }">
    <select
      :id="id"
      ref="select"
      :class="selected"
      @change="checkOptions"
      v-bind="$attrs"
      :value="value"
      v-model="insideValue"
    >
      <option v-if="blank"></option>
      <option
        v-for="(option, iOption) in getOptions()"
        :selected="option.selected"
        :key="iOption"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <label :for="id">{{ title }}</label>
    <span class="select-icon"><i class="fal fa-angle-down"></i></span>
  </div>
</template>

<script>
import Vue from "vue";
import { baseEvents } from "@/mixins/baseEvents.js";

export default {
  mixins: [baseEvents],
  inheritAttrs: false,
  data() {
    return {
      id: "",
      insideValue: this.value,
      selected: "",
    };
  },
  props: {
    title: { type: String },
    blank: { type: Boolean, default: false },
    valid: { type: Boolean, default: true },
    items: {},
  },
  created() {
    // Gerando ID único
    this.id =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  },
  mounted() {
    Vue.nextTick(() => {
      this.checkOptions();
    });
  },
  updated() {
    Vue.nextTick(() => {
      this.checkOptions();
    });
  },
  methods: {
    checkOptions() {
      if (
        this.$refs.select &&
        this.$refs.select.value &&
        this.$refs.select.selectedIndex >= 0
      ) {
        this.selected = "selected";
        this.$emit("input", this.$refs.select.value);
        return true;
      }
      this.selected = "";
    },
    getOptions() {
      let selectedValue = this.$refs.select
        ? this.$refs.select.value
        : this.insideValue;

      if (this.$slots.default) {
        return this.$slots.default.map((option) => {
          let value =
            option.value ||
            (option.data.domProps ? option.data.domProps.value : false);
          return {
            text:
              option.children[0] && option.children[0].text
                ? option.children[0].text
                : "",
            value,
            selected: value == selectedValue,
          };
        });
      } else {
        return this.items.filter((option) => {
          if (!option.disabled) {
            return {
              text: option.text,
              value: option.value,
              selected: selectedValue == option.value,
            };
          }
        });
      }
    },
  },
  watch: {
    insideValue: {
      deep: true,
      handler(newValue) {
        this.$emit("change", { target: this.$refs.select });
      },
    },
    value: function (newValue) {
      this.insideValue = newValue;
    },
  },
};
</script>

<style scoped>
.label-float {
  position: relative;
  padding-top: 10px;
  margin-bottom: 15px;
}

.label-float select {
  background-color: var(--box);
  border: 1px solid var(--input-border);
  border-radius: 5px;
  width: 100%;
  font-size: 12px;
  padding: 14px 15px;
  position: relative;
  font-size: 12px;
  color: #A3A3A3;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
}

.label-float select:focus {
  color: #555;
  outline: 0;
}

.label-float label {
  position: absolute;
  padding: 5px 10px;
  top: 0px;
  left: 5px;
  font-size: 12px;
  display: flex;
  align-items: center;
  -webkit-transition: 0.2s all ease-in-out, background-color 0s;
  -o-transition: 0.2s all ease-in-out, background-color 0s;
  transition: 0.2s all ease-in-out, background-color 0s;
  background-color: var(--box);
  color: var(--input-text);
  border-radius: 5px;
  pointer-events: none;
}

.label-float select + label:empty {
  display: none;
}

.label-float select:focus + label {
  color: var(--input-text);
}

.label-float select:focus {
  color: #AAAAAB;
  background-color: transparent;
  outline: 0;
  border-color: var(--default);
}

.label-float select:focus + label {
  font-weight: 400;
}

.label-float select:disabled,
.label-float select:disabled + label {
  cursor: not-allowed;
  background-color: #f2f2f2 !important;
}

.select-icon {
  position: absolute;
  bottom: 10px;
  right: 15px;
  font-size: 24px;
  color: #505059;
  pointer-events: none;
}

.label-float.invalid select {
  border: 2px solid #9f3041 !important;
}

.invalid select::placeholder {
  color: #9f3041 !important;
}
</style>